import { globalComponents } from 'src/types/globalTypes';
import DirectionPage, {
  MainContent,
  SubTitle,
  Text,
  Img,
  ContentWrapper,
  Annotation,
} from 'src/components/contents/direction/DirectionPage';
import Direction01 from 'src/assets/images/direction/cert/cert_direction_01.svg';
import Direction02 from 'src/assets/images/direction/cert/cert_direction_02.svg';
import Direction03 from 'src/assets/images/direction/cert/cert_direction_03.svg';
import Direction04 from 'src/assets/images/direction/cert/cert_direction_04.svg';
import Direction05 from 'src/assets/images/direction/cert/cert_direction_05.svg';
import { useStore } from 'src/hooks/useStore';
import CertDirectionMobile from './CertDirectionMobile';
import { Link } from 'react-router-dom';

/**
 * 電子證書操作說明。
 */
const CertDirection: React.FC = () => {
  const isMobile = useStore((state) => state.isMobile);
  // 頁面靜態資料
  const component = globalComponents.C;
  const colorType = component.color;
  const linkColor = colorType.fifth;
  const desktopForm = (
    <MainContent>
      <p>電子證書系統提供電子證書驗證與下載服務；以下是其操作說明。</p>
      <SubTitle>電子證書入口：</SubTitle>
      <Text>
        1. 進入
        <Link to={process.env.PUBLIC_URL === '' ? "/" : process.env.PUBLIC_URL} style={{ color: linkColor }}>
          權證查詢系統
        </Link>
        。
      </Text>
      <Text>2. 點擊「電子證書」。</Text>
      <Img src={Direction01} />
      <SubTitle>電子證書驗證：</SubTitle>
      <Text>1. 您可點擊「選擇檔案」區塊將電子證書 pdf 檔上傳。</Text>
      <Img src={Direction02} />
      <Text>2. 輸入驗證碼後，按下「送出驗證」按鈕，即可查詢驗證結果。</Text>
      <Img src={Direction03} />
      <SubTitle>下載證書：</SubTitle>
      <Text>1. 填寫完整專利證書號數或商標註冊號數，以及下載碼。</Text>
      <Text>2. 輸入驗證碼後，按下「下載」按鈕，即可查詢證書檔案。</Text>
      <Img src={Direction04} />
      <Text>3. 點擊 pdf 連結，即可下載證書。</Text>
      <Img src={Direction05} />
    </MainContent>
  );

  return (
    <DirectionPage
      bannerBgImg={component.bgImgResultBanner}
      image={component.hoverImage}
      imgDot={component.bgImgDot}
      bgColor={colorType}
    >
      <ContentWrapper>
        {isMobile ? <CertDirectionMobile color={linkColor} /> : desktopForm}
        <Annotation>若有任何疑問，請洽客服專線：(02)-8176-9009。</Annotation>
      </ContentWrapper>
    </DirectionPage>
  );
};

export default CertDirection;
